export default __webpack_public_path__ + "static/0043-20fdcd2f0db7aba3f5537b860da7da88.png";